import React, { useEffect, useState } from "react";

import FieldSelect from "components/FieldSelect";
import { FieldOption } from "components/FieldSelect/FieldSelect";
import { DataInAnyRow } from "components/PageDashboard/ExternalCommitmentsSection/ExternalCommitmentsTable/ExternalCommitmentsTable";
import { ModalWizardStepRenderProps } from "components/ModalWizard/ModalWizard";

import { getBooleanOptions } from "services/getBooleanOptions";

type Props<T> = {
	wizardDataKey: keyof T;
};

function StepBoolean<T>({
	enableProgressToNextStep,
	disableProgressToNextStep,
	wizardData,
	wizardDataKey,
	...rest
}: ModalWizardStepRenderProps<DataInAnyRow> & Props<T>) {
	const [currentOptions, setCurrentOptions] = useState<FieldOption[]>(
		getBooleanOptions()
	);

	useEffect(() => {
		const selectedOption = currentOptions.find(
			currentOptions => !!currentOptions.selected
		);
		if (!selectedOption) {
			disableProgressToNextStep();
			return;
		}

		if (typeof selectedOption.value !== "boolean") {
			throw new Error("Selected value was not a boolean value");
		}

		enableProgressToNextStep({
			[wizardDataKey]: selectedOption.value
		});
	}, [
		enableProgressToNextStep,
		disableProgressToNextStep,
		currentOptions,
		wizardDataKey
	]);

	return (
		<FieldSelect
			allowMultipleSelections={false}
			currentOptions={currentOptions}
			onNewCurrentOptions={setCurrentOptions}
			useCheckboxes={true}
		/>
	);
}

export default StepBoolean;
